import Shell from '../components/Shell';
import {
  HeroSection,
  WhatAreGoLinksSection,
  UsedAtSection,
  HowItWorksSection,
  FeatureGridSection,
  FAQTeaserSection,
  FinalCTASection,
} from '../components/landing/sections';

export default function LandingPage() {
  return (
    <Shell>
      <HeroSection />
      <WhatAreGoLinksSection />
      <UsedAtSection />
      <HowItWorksSection />
      <FeatureGridSection />
      <FAQTeaserSection />
      <FinalCTASection />
    </Shell>
  );
}
